import axios from 'axios';

const cepea = axios.create({
  baseURL: 'https://www.cepea.esalq.usp.br/br',
});

export default cepea;
